import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from "@ngrx/store";
import {EffectsModule} from "@ngrx/effects";
import {
  ParticipantGroupsListEffects
} from "./core/participant-groups-list.effects";
import {reducer} from "./core/participant-groups-list.reducer";
import {SharedModule} from "../../shared/shared.module";
import {MaterialModule} from "../../shared/material-module";
import {
  ParticipantGroupsListTableComponent
} from './components/participant-groups-list-table/participant-groups-list-table.component';
import {
  ParticipantGroupsListScreenComponent
} from "./screen/participant-groups-list-screen.component";
import {InfiniteScrollModule} from "ngx-infinite-scroll";


@NgModule({
  declarations: [
    ParticipantGroupsListScreenComponent,
    ParticipantGroupsListTableComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    StoreModule.forFeature('ss-cord.participant-groups-list', reducer),
    EffectsModule.forFeature(
      [ParticipantGroupsListEffects]
    ),
    InfiniteScrollModule,
  ]
})
export class ParticipantGroupsListModule {}
